import { Button, Card, Layout, Page, Text, Box } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Box paddingBlockStart="400">
            <Card>
              <Box padding="300">
                <Text as="h1" variant="headingLg">
                  PartFinder
                </Text>
              </Box>
            </Card>
          </Box>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default LandingPage;
